<app-social-shell active="communities">
  <div class="so-card cj-card">
    @if (loading) {
      <p class="cj-muted">Checking your invite…</p>
    } @else if (invalid || !preview) {
      <h1>This invite link isn't valid</h1>
      <p class="cj-muted">It may have been mistyped or turned off. Ask the person who sent it for a new one.</p>
      <a class="btn btn-dark" routerLink="/communities">Browse communities</a>
    } @else {
      <span class="cj-eyebrow">You're invited to join</span>
      <div class="cj-avatar">
        @if (preview.community.image) {
          <img [src]="imageUrl(preview.community.image)" alt="" />
        } @else {
          {{ initials(preview.community.name) }}
        }
      </div>
      <h1>{{ preview.community.name }}</h1>
      <p class="cj-meta">
        <i class="fa" [class.fa-globe]="preview.community.privacy === 'public'" [class.fa-lock]="preview.community.privacy === 'private'"></i>
        {{ preview.community.privacy === 'public' ? 'Public' : 'Private' }} community ·
        {{ preview.community.member_count }} member{{ preview.community.member_count === 1 ? '' : 's' }}
      </p>
      @if (preview.community.description) {
        <p class="cj-desc">{{ preview.community.description }}</p>
      }
      @if (preview.already_member) {
        <p class="cj-muted">You're already a member.</p>
        <a class="btn btn-theme" [routerLink]="['/communities', preview.community.slug]">Open community</a>
      } @else if (!preview.usable) {
        <p class="cj-error">This link has expired or been turned off. Ask for a new one.</p>
        <a class="btn btn-dark" [routerLink]="['/communities', preview.community.slug]">View community</a>
      } @else {
        @if (error) {
          <p class="cj-error" role="alert">{{ error }}</p>
        }
        <button type="button" class="btn btn-theme" [disabled]="joining" (click)="join()">{{ joining ? 'Joining…' : 'Join community' }}</button>
        @if (preview.expires_at) {
          <p class="cj-hint">Link valid until {{ preview.expires_at | date: 'MMM d, h:mm a' }}</p>
        }
      }
    }
  </div>
</app-social-shell>
